import { GetStaticPaths, GetStaticProps } from 'next';

import Page from '@/components/page';
import getPageStaticPaths from '@/lib/get-page-static-paths';
import getPageStaticProps from '@/lib/get-page-static-props';
import contentService from '@/middleware/content-service';
import mapToPageEntry from '@/middleware/mappers/pages/gallery';
import { PageProps } from '@/types/views/generic';

export const getStaticProps: GetStaticProps<PageProps> = async (ctx) =>
  getPageStaticProps({
    fetchPageFn: contentService.getPage(mapToPageEntry),
    getPageFullPath: ({ params }) =>
      `/${params?.event}/galerien/${params?.slug}`,
    theme: 'els',
  })({ ...ctx, params: { ...ctx.params, event: 'live-session' } });

export const getStaticPaths: GetStaticPaths = getPageStaticPaths;

export default Page;
